import { useContext } from 'react';
import { ResultsChartsDataContext } from '../contexts/ResultsChartsDataContext';

export const useResultsChartsDataContext = () => {
    return useContext(ResultsChartsDataContext);
};
